import React, { FC, memo } from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';

import styles, { BASE_FONT_SIZE } from '../pdfStyles';
import { PdfCompanyInfo } from '../Vouchers/voucherHelpers';

const localStyles = StyleSheet.create({
    footer: {
        position: 'absolute',
        bottom: 10,
        right: 0,
        left: 0,
        width: '100%'
    }
});

type Props = {
    companyInfo: PdfCompanyInfo;
};
const PdfFooter: FC<Props> = (props: Props) => {
    const { companyInfo } = props;

    return (
        <View style={[localStyles.footer]} fixed>
            <View style={{ margin: '0 20 2 0', display: 'flex', alignItems: 'flex-end' }}>
                <Text style={{ fontSize: BASE_FONT_SIZE - 4 }}>Issued using Taytan</Text>
            </View>
            <View style={[styles.borderTop, styles.flexRowBetween, { padding: '0 20' }]}>
                <View>
                    <Text style={[styles.littleText]}>
                        {`${companyInfo?.address} Phone: ${companyInfo?.phone} Fax ${companyInfo?.fax} ${companyInfo?.website}`}
                    </Text>
                </View>
                <View>
                    <Text
                        style={[styles.littleText]}
                        render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                    />
                </View>
            </View>
        </View>
    );
};

export default memo(PdfFooter);
